/** The data fields of a generated client DTO class: no methods and no client handle. */
export type DtoFields<T> = {
  [K in keyof T as K extends "client" ? never : T[K] extends (...args: never[]) => unknown ? never : K]?: T[K];
};

/**
 * Sets fields on a generated client DTO. The client serialises only the class's own field names
 * (a configuration is `_configuration`), so pass the fields as an object literal: a misspelt field
 * then fails to compile instead of being dropped from the request.
 */
export function withFields<T extends object>(dto: T, fields: DtoFields<T>): T {
  return Object.assign(dto, fields);
}
